/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import type { DiscoveryProfileSignals } from '@/utils/programDiscoveryEligibility';

function isMissingBirthdayColumn(error: any): boolean {
  return error?.code === '42703';
}

async function fetchDiscoveryProfileSignals(userId?: string): Promise<DiscoveryProfileSignals> {
  if (!userId) {
    return { birthday: null };
  }

  const supabaseUnsafe = supabase as any;
  const { data, error } = await supabaseUnsafe
    .from('profiles')
    .select('*')
    .eq('user_id', userId)
    .maybeSingle();

  if (error) {
    if (isMissingBirthdayColumn(error)) {
      return { birthday: null };
    }
    throw error;
  }

  return {
    birthday:
      data && Object.prototype.hasOwnProperty.call(data, 'birthday')
        ? (data.birthday ?? null)
        : null,
  };
}

export function useDiscoveryProfileSignals(userId?: string) {
  return useQuery({
    queryKey: ['discovery-profile-signals', userId],
    queryFn: () => fetchDiscoveryProfileSignals(userId),
    enabled: !!userId,
    staleTime: 60 * 60 * 1000,
  });
}
